<div [formGroup]="parentForm" class="card-v2">
  <div class="card-v2-title mb-4">{{ 'Contacts.V2.contactCommunicationTitle' | translate }}</div>

  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="control-v2">
        <div class="communication-title-row" [class.communication-title-row--preview]="isPreview">
          <input-label [label]="'Contacts.V2.phone' | translate" customClass="mt-2" />
          <span *ngIf="isPreview && phoneTagLabel" class="communication-tag-preview">
            {{ phoneTagLabel }}
          </span>
          <ng-select
            [hidden]="isPreview"
            class="communication-tag-select new-select"
            [clearable]="true"
            [searchable]="false"
            [items]="communicationTagOptions"
            bindLabel="label"
            bindValue="value"
            [placeholder]="tagPlaceholder"
            [formControlName]="ContactDetails.phoneTag"
          />
        </div>
        <div
          *ngIf="isPreview"
          class="control-v2-info d-flex align-items-center details-content details-content--copyable"
        >
          <div class="iti-flag mr-2" [ngClass]="countryCode"></div>
          <span *ngIf="phone">{{ countryCode | phonePrefix }}</span>
          <span><span class="pii">{{ phone | defaultValue }}</span></span>
          @if (phone) {
            <svg-icon
              class="copy-icon"
              src="/assets/img/ic-copy_to_clipboard_blue.svg"
              (click)="copyValue(phoneToCopy)"
            />
          }
        </div>
        <phone-input-v2
          [hidden]="isPreview"
          [inputPlaceholder]="'Contacts.V2.phonePlaceholder' | translate"
          [form]="parentForm"
          [phoneFlagName]="ContactDetails.phoneCountry"
          [phoneName]="ContactDetails.phone"
        />
      </div>
      <ng-container [formArrayName]="ContactDetails.communications">
        <ng-container *ngFor="let communicationForm of communications.controls; let i = index">
          <div
            [formGroup]="communicationForm"
            class="control-v2 communication-row mt-4"
            [class.mb-4]="i < communications.length - 1"
          >
            <div class="communication-title-row" [class.communication-title-row--preview]="isPreview">
              <input-label [label]="'Contacts.V2.phone' | translate" customClass="mt-2" />
              <span
                *ngIf="isPreview && getTagLabel(communicationForm.get(ContactDetails.tag)?.value)"
                class="communication-tag-preview"
              >
                {{ getTagLabel(communicationForm.get(ContactDetails.tag)?.value) }}
              </span>
              <ng-select
                [hidden]="isPreview"
                class="communication-tag-select new-select"
                [clearable]="true"
                [searchable]="false"
                [items]="communicationTagOptions"
                bindLabel="label"
                bindValue="value"
                [placeholder]="tagPlaceholder"
                [formControlName]="ContactDetails.tag"
              />
            </div>
            @if (isPreview) {
              <div
                class="control-v2-info d-flex align-items-center details-content details-content--copyable"
              >
                <div
                  class="iti-flag mr-2"
                  [ngClass]="communicationForm.get(ContactDetails.phoneCountry)?.value"
                ></div>
                @if (communicationForm.get(ContactDetails.phone)?.value) {
                  <span>
                    <span class="pii">{{ communicationForm.get(ContactDetails.phoneCountry)?.value | phonePrefix }}</span>
                  </span>
                }
                <span><span class="pii">{{ communicationForm.get(ContactDetails.phone)?.value | defaultValue }}</span></span>
                @if (communicationForm.get(ContactDetails.phone)?.value) {
                  <svg-icon
                    class="copy-icon"
                    src="/assets/img/ic-copy_to_clipboard_blue.svg"
                    (click)="copyValue(getCommunicationPhoneToCopy(communicationForm))"
                  />
                }
              </div>
            }
            <div [hidden]="isPreview" class="input-row">
              <phone-input-v2
                [inputPlaceholder]="'Contacts.V2.phonePlaceholder' | translate"
                [form]="communicationForm"
                [phoneFlagName]="ContactDetails.phoneCountry"
                [phoneName]="ContactDetails.phone"
              />

              <app-button
                (onClick)="deleteCommunication(i)"
                type="button"
                [config]="{
                  size: ButtonSize.SMALL,
                  type: ButtonTypes.NEW_PRIMARY_LIGHT_BLUE,
                  prependSrc: '/assets/img/ic-blue-trash-v2.svg'
                }"
              />
            </div>
          </div>
        </ng-container>
      </ng-container>

      <app-button
        [hidden]="isPreview"
        (onClick)="addCommunication()"
        class="btn-v2 mt-2"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
          text: 'Contacts.V2.addButton' | translate,
          prependSrc: '/assets/img/ic-plus.svg'
        }"
      />
    </div>

    <div class="col-12 col-lg-6 mt-4 mt-lg-0">
      <div class="control-v2">
        <div class="communication-title-row" [class.communication-title-row--preview]="isPreview">
          <input-label [label]="'Contacts.V2.email' | translate" customClass="mt-2" />
          <span *ngIf="isPreview && emailTagLabel" class="communication-tag-preview">
            {{ emailTagLabel }}
          </span>
          <ng-select
            [hidden]="isPreview"
            class="communication-tag-select new-select"
            [clearable]="true"
            [searchable]="false"
            [items]="communicationTagOptions"
            bindLabel="label"
            bindValue="value"
            [placeholder]="tagPlaceholder"
            [formControlName]="ContactDetails.emailTag"
          />
        </div>
        <div *ngIf="isPreview" class="control-v2-info details-content details-content--copyable">
          <span><span class="pii">{{ parentForm.get(ContactDetails.email)?.value | defaultValue }}</span></span>
          @if (parentForm.get(ContactDetails.email)?.value) {
            <svg-icon
              class="copy-icon"
              src="/assets/img/ic-copy_to_clipboard_blue.svg"
              (click)="copyValue(parentForm.get(ContactDetails.email)?.value)"
            />
          }
        </div>
        <input-v2
          [hidden]="isPreview"
          [formControlName]="ContactDetails.email"
          [placeholder]="'Contacts.V2.emailPlaceholder' | translate"
        />
      </div>

      <ng-container [formArrayName]="ContactDetails.additionalEmails">
        <ng-container *ngFor="let emailControl of additionalEmails.controls; let i = index">
          <div
            [formGroup]="emailControl"
            class="control-v2 communication-row mt-4"
            [class.mb-4]="i < additionalEmails.length - 1"
          >
            <div class="communication-title-row" [class.communication-title-row--preview]="isPreview">
              <input-label [label]="'Contacts.V2.email' | translate" customClass="mt-2" />
              <span
                *ngIf="isPreview && getTagLabel(emailControl.get(ContactDetails.tag)?.value)"
                class="communication-tag-preview"
              >
                {{ getTagLabel(emailControl.get(ContactDetails.tag)?.value) }}
              </span>
              <ng-select
                [hidden]="isPreview"
                class="communication-tag-select new-select"
                [clearable]="true"
                [searchable]="false"
                [items]="communicationTagOptions"
                bindLabel="label"
                bindValue="value"
                [placeholder]="tagPlaceholder"
                [formControlName]="ContactDetails.tag"
              />
            </div>
            @if (isPreview) {
              <div class="control-v2-info details-content details-content--copyable">
                <span><span class="pii">{{ emailControl.get(ContactDetails.email)?.value | defaultValue }}</span></span>
                @if (emailControl.get(ContactDetails.email)?.value) {
                  <svg-icon
                    class="copy-icon"
                    src="/assets/img/ic-copy_to_clipboard_blue.svg"
                    (click)="copyValue(emailControl.get(ContactDetails.email)?.value)"
                  />
                }
              </div>
            }
            <div [hidden]="isPreview" class="input-row">
              <input-v2
                class="communication-row__input"
                [formControlName]="ContactDetails.email"
                [placeholder]="'Contacts.V2.emailPlaceholder' | translate"
              />

              <app-button
                (onClick)="deleteAdditionalEmail(i)"
                type="button"
                [config]="{
                  size: ButtonSize.SMALL,
                  type: ButtonTypes.NEW_PRIMARY_LIGHT_BLUE,
                  prependSrc: '/assets/img/ic-blue-trash-v2.svg'
                }"
              />
            </div>
          </div>
        </ng-container>
      </ng-container>

      <app-button
        [hidden]="isPreview"
        (onClick)="addAdditionalEmail()"
        class="btn-v2 mt-2"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
          text: 'Contacts.V2.addButton' | translate,
          prependSrc: '/assets/img/ic-plus.svg'
        }"
      />
    </div>
  </div>

  <div class="mt-4">
    <div *ngIf="isPreview" class="mb-4">
      <div class="control-v2">
        <input-label [label]="'Contacts.V2.address' | translate" />
        <div class="control-v2-info details-content details-content--copyable">
          <ng-container *ngIf="hasAddress(); else noAddress">
            <span>{{ formattedAddress }}</span>
            <svg-icon
              class="copy-icon"
              src="/assets/img/ic-copy_to_clipboard_blue.svg"
              (click)="copyValue(formattedAddress)"
            />
          </ng-container>

          <ng-template #noAddress><span>-</span></ng-template>
        </div>
      </div>
    </div>

    <address-with-autocomplete-v2
      *ngIf="!isPreview"
      [form]="parentForm"
      [config]="addressConfig"
      [hideFieldLabels]="true"
    />
  </div>

  <hr class="spacer-v2 spacer-v2-light mt-1 mb-4" />
  <div class="mb-4">
    <input-label [label]="'Contacts.V2.webInfoTitle' | translate" />
    <ng-container *ngIf="isPreview && parentForm.get(ContactDetails.links).value as links">
      <div class="control-v2-info mb-1" *ngFor="let linkData of links">
        <div>{{ linkData.link }}</div>
      </div>
      <span class="control-v2-info" *ngIf="links.length === 0">-</span>
    </ng-container>
  </div>

  <ng-container [formArrayName]="ContactDetails.links">
    <div
      class="row-grid mb-4"
      [hidden]="isPreview"
      [formGroup]="linkForm"
      *ngFor="let linkForm of links.controls; let i = index"
    >
      <div class="row">
        <div class="col-12 col-md-6">
          <input-v2
            [formControlName]="ContactDetails.linkName"
            [placeholder]="'Contacts.V2.linkNamePlaceholder' | translate"
          />
        </div>

        <div class="col-12 col-md-6 mt-3 mt-md-0">
          <input-v2
            [formControlName]="ContactDetails.linkUrl"
            [placeholder]="'Contacts.V2.linkUrlPlaceholder' | translate"
          />
        </div>
      </div>

      <app-button
        (onClick)="deleteWebInfo(i)"
        [type]="'button'"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_PRIMARY_LIGHT_BLUE,
          prependSrc: '/assets/img/ic-blue-trash-v2.svg'
        }"
      />
    </div>

    <app-button
      [hidden]="isPreview"
      [type]="'button'"
      (onClick)="addWebInfo()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
        text: 'Contacts.V2.addButton' | translate,
        prependSrc: '/assets/img/ic-plus.svg'
      }"
    />
  </ng-container>
</div>
